module.exports = __webpack_public_path__ + "static/feature-autotracker-3564bf4f714c41ebf64c711e2532c2e3.png";